/* eslint-disable require-jsdoc */
export async function handleUserAuthenticated(userName) {
  const authToken = await getUserAuthToken();
  if (authToken && authToken.value) {
    notifyParent({
      status: 'success',
      userName: userName,
      authToken: authToken
    });
  } else {
    handleUserAuthenticationFailed();
  }
}

export function handleUserAuthenticationFailed(userName, error) {
  notifyParent({
    status: 'failed',
    userName: userName,
    error: error?.message
  });
}

export function handleUserAuthenticationStarted() {
  notifyParent({
    status: 'started'
  });
}

async function getUserAuthToken() {
  return fetch('/users/auth-token', {
    method: 'GET',
    credentials: 'same-origin'
  }).then((response) => {
    return {
      value: response.headers.get('x-auth-token'),
      maxAgeInSeconds: getUnsignedLongValue(
        response.headers.get('x-auth-token-max-age')
      ),
      maxAgeStartTimeInSeconds: getUnsignedLongValue(
        response.headers.get('x-auth-token-max-age-start-time')
      )
    };
  });
}

function getUnsignedLongValue(value) {
  if (value === undefined) {
    return undefined;
  }

  let parsed;

  if (typeof value === 'string') {
    parsed = Number.parseInt(value);
  } else if (typeof value === 'number') {
    parsed = value;
  }

  if (parsed === undefined || Number.isNaN(parsed)) {
    return undefined;
  }

  return value < 0 ? undefined : parsed;
}

function notifyParent(message) {
  const parent = window.parent;
  if (parent) {
    console.log('Sending message to parent window: ' + JSON.stringify(message));
    parent.postMessage(message, '*');
  }
}
